/* eslint-disable */
const Emojiis = [
	{
        txt: "<3",
        code: "2764"
      },
      {
        txt: "</3",
        code: "1F494"
      },
      {
        txt: ":\")",
        code: "1F602"
      },
      {
        txt: ":\"-)",
        code: "1F602"
      },
      {
        txt: ":D",
        code: "1F603"
      },
      {
        txt: ":-D",
        code: "1F603"
      },
      {
        txt: "=D",
        code: "1F603"
      },
      {
        txt: ":)",
        code: "1F604"
      },
      {
        txt: ":-)",
        code: "1F604"
      },
      {
        txt: "=]",
        code: "1F604"
      },
      {
        txt: "=)",
        code: "1F604"
      },
      {
        txt: ":]",
        code: "1F604"
      },
      {
        txt: "\":)",
        code: "1F605"
      },
      {
        txt: "\":-)",
        code: "1F605"
      },
      {
        txt: "\"=)",
        code: "1F605"
      },
      {
        txt: "\":D",
        code: "1F605"
      },
      {
        txt: "\":-D",
        code: "1F605"
      },
      {
        txt: "\"=D",
        code: "1F605"
      },
      {
        txt: ">,)",
        code: "1F606"
      },
      {
        txt: ">;)",
        code: "1F606"
      },
      {
        txt: ">,-)",
        code: "1F606"
      },
      {
        txt: ">=)",
        code: "1F606"
      },
      {
        txt: ";)",
        code: "1F609"
      },
      {
        txt: ";-)",
        code: "1F609"
      },
      {
        txt: "*-)",
        code: "1F609"
      },
      {
        txt: "*)",
        code: "1F609"
      },
      {
        txt: ";-]",
        code: "1F609"
      },
      {
        txt: ";]",
        code: "1F609"
      },
      {
        txt: ";D",
        code: "1F609"
      },
      {
        txt: ";^)",
        code: "1F609"
      },
      {
        txt: "\":(",
        code: "1F613"
      },
      {
        txt: "\":-(",
        code: "1F613"
      },
      {
        txt: "\"=(",
        code: "1F613"
      },
      {
        txt: ":*",
        code: "1F618"
      },
      {
        txt: ":-*",
        code: "1F618"
      },
      {
        txt: "=*",
        code: "1F618"
      },
      {
        txt: ":^*",
        code: "1F618"
      },
      {
        txt: ">,P",
        code: "1F61c"
      },
      {
        txt: "X-P",
        code: "1F61c"
      },
      {
        txt: "x-p",
        code: "1F61c"
      },
      {
        txt: ">,[",
        code: "1F61e"
      },
      {
        txt: ":-(",
        code: "1F61e"
      },
      {
        txt: ":(",
        code: "1F61e"
      },
      {
        txt: ":-[",
        code: "1F61e"
      },
      {
        txt: ":[",
        code: "1F61e"
      },
      {
        txt: "=(",
        code: "1F61e"
      },
      {
        txt: ">,(",
        code: "1F620"
      },
      {
        txt: ">,-(",
        code: "1F620"
      },
      {
        txt: ":@",
        code: "1F620"
      },
      {
        txt: ":\"(",
        code: "1F622"
      },
      {
        txt: ":\"-(",
        code: "1F622"
      },
      {
        txt: ";(",
        code: "1F622"
      },
      {
        txt: ";-(",
        code: "1F622"
      },
      {
        txt: ">.<",
        code: "1F623"
      },
      {
        txt: ":$",
        code: "1F633"
      },
      {
        txt: "=$",
        code: "1F633"
      },
      {
        txt: "#-)",
        code: "1F635"
      },
      {
        txt: "#)",
        code: "1F635"
      },
      {
        txt: "%-)",
        code: "1F635"
      },
      {
        txt: "%)",
        code: "1F635"
      },
      {
        txt: "X)",
        code: "1F635"
      },
      {
        txt: "X-)",
        code: "1F635"
      },
      {
        txt: "*\\0/*",
        code: "1F646"
      },
      {
        txt: "\\0/",
        code: "1F646"
      },
      {
        txt: "*\\O/*",
        code: "1F646"
      },
      {
        txt: "\\O/",
        code: "1F646"
      },
      {
        txt: "O,-)",
        code: "1F607"
      },
      {
        txt: "0,-3",
        code: "1F607"
      },
      {
        txt: "0,3",
        code: "1F607"
      },
      {
        txt: "0,-)",
        code: "1F607"
      },
      {
        txt: "0,)",
        code: "1F607"
      },
      {
        txt: "0;^)",
        code: "1F607"
      },
      {
        txt: "O,)",
        code: "1F607"
      },
      {
        txt: "O;-)",
        code: "1F607"
      },
      {
        txt: "O=)",
        code: "1F607"
      },
      {
        txt: "0;-)",
        code: "1F607"
      },
      {
        txt: "O,-3",
        code: "1F607"
      },
      {
        txt: "O,3",
        code: "1F607"
      },
      {
        txt: "B-)",
        code: "1F60e"
      },
      {
        txt: "B)",
        code: "1F60e"
      },
      {
        txt: "8)",
        code: "1F60e"
      },
      {
        txt: "8-)",
        code: "1F60e"
      },
      {
        txt: "B-D",
        code: "1F60e"
      },
      {
        txt: "8-D",
        code: "1F60e"
      },
      {
        txt: "-_-",
        code: "1F611"
      },
      {
        txt: "-__-",
        code: "1F611"
      },
      {
        txt: "-___-",
        code: "1F611"
      },
      {
        txt: ">,\\",
        code: "1F615"
      },
      {
        txt: ">,/",
        code: "1F615"
      },
      {
        txt: ":-/",
        code: "1F615"
      },
      {
        txt: ":-.",
        code: "1F615"
      },
      {
        txt: ":/",
        code: "1F615"
      },
      {
        txt: ":\\",
        code: "1F615"
      },
      {
        txt: "=/",
        code: "1F615"
      },
      {
        txt: "=\\",
        code: "1F615"
      },
      {
        txt: ":L",
        code: "1F615"
      },
      {
        txt: "=L",
        code: "1F615"
      },
      {
        txt: ":P",
        code: "1F61b"
      },
      {
        txt: ":-P",
        code: "1F61b"
      },
      {
        txt: "=P",
        code: "1F61b"
      },
      {
        txt: ":-p",
        code: "1F61b"
      },
      {
        txt: ":p",
        code: "1F61b"
      },
      {
        txt: "=p",
        code: "1F61b"
      },
      {
        txt: ":-Þ",
        code: "1F61b"
      },
      {
        txt: ":Þ",
        code: "1F61b"
      },
      {
        txt: ":þ",
        code: "1F61b"
      },
      {
        txt: ":-þ",
        code: "1F61b"
      },
      {
        txt: ":-b",
        code: "1F61b"
      },
      {
        txt: ":b",
        code: "1F61b"
      },
      {
        txt: "d,",
        code: "1F61b"
      },
      {
        txt: ":-O",
        code: "1F62e"
      },
      {
        txt: ":O",
        code: "1F62e"
      },
      {
        txt: ":-o",
        code: "1F62e"
      },
      {
        txt: ":o",
        code: "1F62e"
      },
      {
        txt: "O_O",
        code: "1F62e"
      },
      {
        txt: ">,O",
        code: "1F62e"
      },
      {
        txt: ":-X",
        code: "1F636"
      },
      {
        txt: ":X",
        code: "1F636"
      },
      {
        txt: ":-#",
        code: "1F636"
      },
      {
        txt: ":#",
        code: "1F636"
      },
      {
        txt: "=X",
        code: "1F636"
      },
      {
        txt: "=x",
        code: "1F636"
      },
      {
        txt: ":x",
        code: "1F636"
      },
      {
        txt: ":-x",
        code: "1F636"
      },
      {
        txt: "=#",
        code: "1F636"
      }
    ];

    // Replace emojiis with text presentation of the emoji until we handle emojis...
    // https://en.wikipedia.org/wiki/List_of_emoticons
    const SupportedTextEmojis = [
        {
            emoji: '🙂😊😀😁',
            text: ':-)'
        },
        {
            emoji: '😛😝😜🤑',
            text: ':-P'
        },
        {
            emoji: '❤️',
            text: '<3'
        },
        {
            emoji: '💔',
            text: '<\\3'
        },
        {
            emoji: '😃😄😆😍',
            text: ':‑D'
        }
        // Testing:  🤛🙀
    ];

    function emojiUnicode (emoji) {
        
        var comp;
        if (emoji.length === 1) {
            comp = emoji.charCodeAt(0);
        }
        comp = (
            (emoji.charCodeAt(0) - 0xD800) * 0x400
          + (emoji.charCodeAt(1) - 0xDC00) + 0x10000
        );
        if (comp < 0) {
            comp = emoji.charCodeAt(0);
        }
        return comp.toString("16");
    }

/**
 * Replaces emojiis with text emojiis
 * @param {String} str - The string to replace
 */

export const replaceEmojiisWithText = (str) => {

    const emojiTree = require('emoji-tree');
    let array = emojiTree(str);
    let cleanString = '';
    
    array.forEach((char) => {
        if(char.type == 'text'){
            cleanString += char.text;
        }else{
            let emoji = ' ';
            SupportedTextEmojis.forEach((item) => {
                if(item.emoji.includes(char.text)){
                    emoji = item.text;
                }
            });
            cleanString += emoji;
        }
        
        
    });

    return cleanString;
};

export const textContainsEmojis = (str) => {

    const emojiTree = require('emoji-tree');
    let array = emojiTree(str).filter(item => item.type == 'emoji');
    
    return array.length > 0;
};

export default {
    replaceEmojiisWithText,
    textContainsEmojis
}
